import { render, staticRenderFns } from "./DanhSachDaiLyTinh.vue?vue&type=template&id=c2fef388&scoped=true&"
import script from "./DanhSachDaiLyTinh.vue?vue&type=script&lang=js&"
export * from "./DanhSachDaiLyTinh.vue?vue&type=script&lang=js&"
import style0 from "./DanhSachDaiLyTinh.vue?vue&type=style&index=0&id=c2fef388&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2fef388",
  null
  
)

export default component.exports